import { ExecutiveOverviewTypes, CMPerformanceRequestParams, PHICTrendDataRequestParams } from "../types/executiveOverviewTypes";
import { config } from "../../config/config";

/**
 * Fetch PHIC Trend filter options.
 */
export const getPHICTrendFiltersRequest = () => ({
  type: ExecutiveOverviewTypes.GET_PHIC_TREND_FILTERS_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/executive/phic-trend/filters`,
        method: "GET",
      },
      commit: { type: ExecutiveOverviewTypes.GET_PHIC_TREND_FILTERS_SUCCESS },
      rollback: { type: ExecutiveOverviewTypes.GET_PHIC_TREND_FILTERS_FAILURE },
    },
  },
});

/**
 * Fetch CM Performance dashboard data (risk table + PHIC records).
 * @param params.period - One of: current_week, last_week, current_month, last_month
 * @param params.date - ISO date string
 */
export const getCMPerformanceRequest = (params: CMPerformanceRequestParams) => ({
  type: ExecutiveOverviewTypes.GET_CM_PERFORMANCE_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/executive/cm-performance?period=${params.period}&date=${params.date}`,
        method: "GET",
      },
      commit: { type: ExecutiveOverviewTypes.GET_CM_PERFORMANCE_SUCCESS },
      rollback: { type: ExecutiveOverviewTypes.GET_CM_PERFORMANCE_FAILURE },
    },
  },
});

/**
 * Fetch PHIC Trend chart data (monthly stacked bar chart).
 * Optional query params: operation, cm, location (for filtering)
 * 
 * @param params.start_time - Start month in YYYY-MM format
 * @param params.end_time - End month in YYYY-MM format
 * @param params.group_by - Grouping dimension: "program" | "cause_type" | "alert_type" (default: "program")
 * @param params.operation - Optional: filter by operation
 * @param params.cm - Optional: filter by CM
 * @param params.location - Optional: filter by location
 */
export const getPHICTrendDataRequest = (params: PHICTrendDataRequestParams) => {
  // Build query string with required and optional params
  const queryParams = new URLSearchParams();
  queryParams.set("start_time", params.start_time);
  queryParams.set("end_time", params.end_time);
  if (params.group_by) queryParams.set("group_by", params.group_by);
  if (params.operation) queryParams.set("operation", params.operation);
  if (params.cm) queryParams.set("cm", params.cm);
  if (params.location) queryParams.set("location", params.location);

  return {
    type: ExecutiveOverviewTypes.GET_PHIC_TREND_DATA_REQUEST,
    http: {
      cognito: {
        effect: {
          url: `${(config as any).BASE_URL}/executive/phic-trend?${queryParams.toString()}`,
          method: "GET",
        },
        commit: { type: ExecutiveOverviewTypes.GET_PHIC_TREND_DATA_SUCCESS },
        rollback: { type: ExecutiveOverviewTypes.GET_PHIC_TREND_DATA_FAILURE },
      },
    },
  };
};
